"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "novella": {
    "4f2bfca1": [{
      "hkey": "fee56406",
      "slug": "novella",
      "name": "Novella",
      "primary": true,
      "skipSearch": false
    }],
    "frari": [{
      "hkey": "fee56406",
      "slug": "novella",
      "name": "Novella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "81a030ca": [{
      "hkey": "fee56406",
      "slug": "novella",
      "name": "Novella",
      "primary": true,
      "skipSearch": false
    }],
    "rivo": [{
      "hkey": "fee56406",
      "slug": "novella",
      "name": "Novella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "555305cc": [{
      "hkey": "b401980e",
      "slug": "brez-traversara",
      "name": "Brez-Traversara",
      "primary": true,
      "skipSearch": false
    }],
    "traversara": [{
      "hkey": "b401980e",
      "slug": "brez-traversara",
      "name": "Brez-Traversara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;